import OutlierDetectorEditDto from './OutlierDetectorEditDto';

export class AutoEncoderModelEditDto extends OutlierDetectorEditDto {
	constructor() {
		super();

		/** @type {number} */
		this.train_epochs = null;
		/** @type {number} */
		this.train_batch_size = null;
		/** @type {number[]} */
		this.encoder_dimensions = null;
		/** @type {number[]} */
		this.decoder_dimensions = null;
	}

	/**
	 * @typedef {Object} _AutoEncoderModelEditDtoProps
	 * @property {number} train_epochs
	 * @property {number} train_batch_size
	 * @property {number[]} encoder_dimensions
	 * @property {number[]} decoder_dimensions
	 *
	 * @typedef {import("./OutlierDetectorEditDto").OutlierDetectorEditDtoProps & _AutoEncoderModelEditDtoProps} AutoEncoderModelEditDtoProps
	 */
	/**
	 *
	 * @param {AutoEncoderModelEditDtoProps} props
	 * @returns {AutoEncoderModelEditDto}
	 */
	setup(props) {
		super.setup(props);

		this.train_epochs = props.train_epochs;
		this.train_batch_size = props.train_batch_size;

		this.encoder_dimensions = props.encoder_dimensions ?? [];
		this.decoder_dimensions = props.decoder_dimensions ?? [];

		// Convert arrays to strings for easier display
		this.encoder_dimensions_str = props.encoder_dimensions?.join(',') ?? '';
		this.decoder_dimensions_str = props.decoder_dimensions?.join(',') ?? '';

		return this;
	}

}

export default AutoEncoderModelEditDto;